import * as React from "react";

type FullscreenWritingContextValue = {
  fullscreen: boolean;
  setFullscreen: (value: boolean) => void;
};

const FullscreenWritingContext = React.createContext<FullscreenWritingContextValue | null>(null);

export function FullscreenWritingProvider({ children }: { children: React.ReactNode }) {
  const [fullscreen, setFullscreen] = React.useState(false);
  const value = React.useMemo(() => ({ fullscreen, setFullscreen }), [fullscreen]);
  return (
    <FullscreenWritingContext.Provider value={value}>
      {children}
    </FullscreenWritingContext.Provider>
  );
}

export function useFullscreenWriting() {
  const ctx = React.useContext(FullscreenWritingContext);
  if (!ctx) return { fullscreen: false, setFullscreen: () => {} };
  return ctx;
}
